import {FC, memo} from "react";
import {Item, Root} from "./SectionVariants-styles";
import {SectionVariantsProps} from "./SectionVariants-types";
import SectionVariantsOption from "./components/SectionVariantsOption/SectionVariantsOption";
import {useFilteredVariants} from "./SectionVariants-hooks";

const SectionVariants: FC<SectionVariantsProps> = memo((props) => {
    const {uid, options, onOptionSelect} = props;

    const variants = useFilteredVariants(options);

    return (
        <Root>
            {
                variants.map((option) => (
                    <Item key={option.id}>
                        <SectionVariantsOption uid={uid} option={option} onClick={onOptionSelect}/>
                    </Item>
                ))
            }
        </Root>
    )
});

export default SectionVariants;
